import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=b7b5153c"
import script from "./YearSelector.vue?vue&type=script&lang=js"
export * from "./YearSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports